import { Link } from 'react-router';
import PropTypes from 'prop-types';

import { ROUTES } from '#/config/routes';
import { Badge } from '#/modules/commonComponents/badge';
import {
  formatStocktakeAnomalyLabel,
  isComparisonRowAbnormal,
  resolveComparisonStocktakeItems,
} from '#/modules/imsMgmt/receipts/stocktake/helper/comparisonDisplay';

export function StocktakeComparisonAnomalyBadges({ anomalies = [] }) {
  if (!Array.isArray(anomalies) || anomalies.length === 0) {
    return <span className="text-slate-400">—</span>;
  }

  return (
    <div className="flex flex-wrap gap-1">
      {anomalies.map((code) => (
        <Badge
          key={code}
          variant="outline"
          className="border-amber-300 bg-amber-50 text-amber-900"
        >
          {formatStocktakeAnomalyLabel(code)}
        </Badge>
      ))}
    </div>
  );
}

StocktakeComparisonAnomalyBadges.propTypes = {
  anomalies: PropTypes.arrayOf(PropTypes.string),
};

export function StocktakeComparisonIdsExpand({ row }) {
  const items = resolveComparisonStocktakeItems(row);
  const count = row.stocktakeCount ?? items.length;
  const abnormal = isComparisonRowAbnormal(row);

  if (items.length === 0) {
    return (
      <span className="text-slate-500">
        {count > 0 ? String(count) : '—'}
      </span>
    );
  }

  if (!abnormal && items.length <= 1) {
    const only = items[0];
    return (
      <Link
        className="table_action_link text-sm"
        to={ROUTES.stocktakeDetail(only.id)}
        onClick={(event) => event.stopPropagation()}
      >
        {only.no || only.id}
      </Link>
    );
  }

  return (
    <details
      className="text-sm"
      onClick={(event) => event.stopPropagation()}
    >
      <summary className="cursor-pointer text-primary-700">
        {count || items.length}
        {' '}
        筆（展開）
      </summary>
      <ul className="mt-1 space-y-1 pl-1">
        {items.map((item) => (
          <li key={item.id}>
            <Link
              className="table_action_link break-all"
              to={ROUTES.stocktakeDetail(item.id)}
            >
              {item.no || item.id}
            </Link>
          </li>
        ))}
      </ul>
    </details>
  );
}

StocktakeComparisonIdsExpand.propTypes = {
  row: PropTypes.object.isRequired,
};
